import { QRCodeSVG } from "qrcode.react";
import { useEffect, useState } from "react";

import getFacebookDetails from "./api/getFacebookDetails";

const FacebookIntegration = ({ botId }) => {
  const [connectedPages, setConnectedPages] = useState([]);
  const [selectedPage, setSelectedPage] = useState(null);

  // Fetch Facebook data on botId change
  useEffect(() => {
    const fetchData = async () => {
      const response = await getFacebookDetails(botId);
      if (!response.error && response?.facebookData) {
        setConnectedPages(response?.facebookData);
        if (response?.facebookData.length > 0) {
          setSelectedPage(response?.facebookData[0]); // Select the first page by default
        }
      }
    };

    fetchData();
  }, [botId]);

  // Handle page selection
  const handlePageSelect = (event) => {
    const selectedPageId = event.target.value;
    const page = connectedPages.find((page) => page.page_id === selectedPageId);
    setSelectedPage(page);
  };

  return (
    <div className="flex flex-col space-y-6 text-lg">
      {/* Connected Facebook Pages Section */}
      <div className="bg-white shadow-lg rounded-xl p-6">
        <h3 className="text-3xl font-semibold text-gray-900 mb-4">
          Connected Facebook Pages
        </h3>

        {/* Table Header - Hidden on small screens */}
        <div className="hidden md:grid md:grid-cols-3 bg-gray-100 text-gray-700 font-medium p-3">
          <div className="text-left">Page ID</div>
          <div className="text-left">Page Name</div>
          <div className="text-left">Status</div>
        </div>

        {/* Table Body */}
        {connectedPages.length > 0 ? (
          connectedPages.map((page) => (
            <div
              key={page.page_id}
              className="grid grid-cols-1 md:grid-cols-3 gap-y-2 p-4 border-b hover:bg-gray-50 transition text-gray-800">
              <div className="md:col-span-1">
                <span className="font-medium text-gray-500 md:hidden block mb-1">
                  Page ID:
                </span>
                {page.page_id}
              </div>
              <div className="md:col-span-1">
                <span className="font-medium text-gray-500 md:hidden block mb-1">
                  Page Name:
                </span>
                {page.page_name}
              </div>
              <div className="md:col-span-1">
                <span className="font-medium text-gray-500 md:hidden block mb-1">
                  Status:
                </span>
                <span className="font-medium text-green-600">Connected</span>
              </div>
            </div>
          ))
        ) : (
          <div className="p-4 text-gray-500">No Facebook pages connected</div>
        )}
      </div>

      {/* Test Integration Section */}
      <div className="bg-white shadow-lg rounded-xl p-6">
        <h6 className="text-xl font-semibold mb-2">Test Your Integration</h6>
        <p className="text-gray-700 mb-4">
          You can test your WhatsApp integration by sending a message to your
          linked number. Scan the QR code using your smartphone to start
          chatting.
        </p>

        {/* Dropdown to Select a Facebook Page */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between space-y-4 sm:space-y-0 sm:space-x-6">
          {connectedPages.length > 0 && (
            <div className="w-full sm:w-1/2 mb-6">
              <label
                htmlFor="pageSelect"
                className="block text-gray-700 font-medium mb-2">
                Select a Facebook Page
              </label>
              <select
                id="pageSelect"
                className="w-full p-2 border border-gray-300 rounded-lg"
                onChange={handlePageSelect}
                value={selectedPage?.page_id || ""}>
                {connectedPages.map((page) => (
                  <option key={page.page_id} value={page.page_id}>
                    {page.page_name}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* QR Code for Selected Page */}
          {selectedPage && (
            <div className="w-full sm:w-1/2 flex items-end justify-end">
              <div className="w-fit">
                <QRCodeSVG
                  value={`https://facebook.com/${selectedPage.page_id}`}
                  size={160}
                  className="mx-auto sm:mx-0"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FacebookIntegration;
